import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=3fb0eb72&scoped=true"
import script from "./Header.ts?vue&type=script&lang=ts&external"
export * from "./Header.ts?vue&type=script&lang=ts&external"
import style0 from "./Header.vue?vue&type=style&index=0&id=3fb0eb72&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb0eb72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fb0eb72')) {
      api.createRecord('3fb0eb72', component.options)
    } else {
      api.reload('3fb0eb72', component.options)
    }
    module.hot.accept("./Header.vue?vue&type=template&id=3fb0eb72&scoped=true", function () {
      api.rerender('3fb0eb72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/AtrContracts/components/Header/Header.vue"
export default component.exports